/**
 * Design steady state. Regenerate with `npx tsx tools/settle.ts water-treatment` after
 * changing equipment sizing or tuning; the 8-hour stability test asserts the plant stays
 * here with no operator action.
 */
export const designPreset: Record<string, number> = {
  // The clearwell level controller starts at the OP that maps to a 500 m³/h plant rate
  // through FIC-101's setpoint range of 200–700 m³/h.
  'LIC-501.OP': 60,
  'P-101A.RUN': 1,
  'P-101B.RUN': 1,
  'P-701A.RUN': 1,
  'P-701B.RUN': 1,
  'SPD-101': 70,
  'SPD-701': 82,
  'PD-201.CMD': 24,
  'PD-601.CMD': 33.3,
  'PD-602.CMD': 22,
  'BV-301.CMD': 0,
  'IV-401.CMD': 100,
  'IV-402.CMD': 100,
  'IV-403.CMD': 100,
  'IV-404.CMD': 100,
  'FV-401.CMD': 76,
  'FV-402.CMD': 76,
  'FV-403.CMD': 76,
  'FV-404.CMD': 76,
};
